/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_GuideInputs */

const en_gc_editor_guide = /** @type {(inputs: Gc_Editor_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick-start guide`)
};

const zh_gc_editor_guide = /** @type {(inputs: Gc_Editor_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`入门指南`)
};

/**
* | output |
* | --- |
* | "Quick-start guide" |
*
* @param {Gc_Editor_GuideInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_guide = /** @type {((inputs?: Gc_Editor_GuideInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_GuideInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_guide(inputs)
	return zh_gc_editor_guide(inputs)
});
export { gc_editor_guide as "gc.editor.guide" }